// Libraries
import { Fragment } from 'react';
import { Text, Flex, Tooltip } from '@chakra-ui/react';
// Types
import { ParentHeaderCellProps } from './ParentHeaderCell.types';
import { QuestionOutlineIcon } from '@chakra-ui/icons';

/**
 * ParentHeaderCell component represents a cell in the parent header row.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.label - The label for the cell.
 * @param {Object} [props.tooltip] - The tooltip configuration for the cell.
 * @param {boolean} [props.bottomBorder=false] - Determines whether to display the bottom border of the cell.
 * @returns {ReactElement} ParentHeaderCell component.
 */
export const ParentHeaderCell = ({ label, tooltip, bottomBorder = false, className }: ParentHeaderCellProps) => (
  <Flex
    borderBottom={bottomBorder ? 'section' : 'none'}
    minH={8}
    justifyContent='center'
    alignItems='center'
    columnGap={1}
    className={className}
  >
    {typeof label === 'string' ? <Text textAlign='center'>{label}</Text> : <>{label}</>}
    {!!tooltip && (
      <Tooltip
        hasArrow
        placement='top'
        openDelay={100}
        closeDelay={200}
        gutter={12}
        bg='white'
        label={
          <Fragment>
            <Text>{tooltip.title}</Text>
            <Text variant='faded' noOfLines={4}>
              {tooltip.description}
            </Text>
          </Fragment>
        }
      >
        <QuestionOutlineIcon
          transition='all 0.2s ease-in-out'
          color='grey.100'
          boxSize={3}
          _hover={{
            color: 'base',
          }}
        />
      </Tooltip>
    )}
  </Flex>
);
